
import React from 'react';

const GraphBlueUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='64'
			height='65'
			fill='none'
			viewBox='0 0 64 65'
		>
			<g fill='#7BDBDC' clipPath='url(#clip0)'>
				<path d='M56 52.5H10c-1.1 0-2-.9-2-2v-42h4v40h44v4z'></path>
				<path d='M52 44.5h-8c-1.1 0-2-.9-2-2v-16c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2zm-6-4h4v-12h-4v12zM38 44.5h-8c-1.1 0-2-.9-2-2v-26c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v26c0 1.1-.9 2-2 2zm-6-4h4v-22h-4v22zM24 44.5h-8c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2zm-6-4h4v-8h-4v8zM56 60.5H8v4h48v-4z'></path>
			</g>
			<defs>
				<clipPath id='clip0'>
					<path
						fill='#fff'
						d='M0 0H64V64H0z'
						transform='translate(0 .5)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default GraphBlueUnderline;
